<template>
    <div
            id="music-box"
            class="music-box">
        <div class="btns-box">
            <p
                v-if="authUpload"
                class="btn upload"
                @click="batchUpload">批量上传</p>
            <p
                v-if="authUpload"
                class="btn upload"
                @click="upload">上传音频</p>
            <p
                v-if="authAiRecord"
                class="btn ai"
                @click="aiRecord">AI语音合成</p>
            <p
                v-if="authRecord"
                class="btn record"
                @click="record">网页录制</p>
            <p
                v-if="authWxRecord"
                class="btn weixin"
                @click="wxRecord">微信录制</p>
        </div>
        <div
                class="music-list"
                v-if="data && data.length>0">
            <div
                    class="list"
                    :class="{active: item.play}"
                    v-for="(item, index) in data"
                    :key="index"
                    @click="selectAudio(item, index)"
            >
                <div class="music-txt">
                    <div class="row-one">
                        <p class="name">{{item.alias || item.name}}</p>
                        <div class="operation">
                        </div>
                    </div>
                    <div class="play-bar">
                        <p class="play btn">
                            <img
                                    v-if="!item.play"
                                    crossOrigin="anonymous"
                                    @click="play(item, item.playTime>0)"
                                    class="img"
                                    :src="$images.material.dazanting"
                                    alt="img" />
                            <img v-else
                                 @click="pause"
                                 crossOrigin="anonymous"
                                 class="img"
                                 :src="$images.material.dabofang"
                                 alt="img" />
                        </p>
                        <div class="txt-box">
                            <p class="bar">
                                <el-slider
                                        v-model="item.playTime"
                                        :show-tooltip="false"
                                        :disabled="!(curEditId === item.id)"
                                        @input="onSlider($event, item)"
                                        @change="continuePlay($event, item, index)"
                                ></el-slider>
                            </p>
                            <p class="txt">
                                <span class="time">{{item.isKuaijin?getTimeDislay(item.playTime):item.curTimeShow || '0:00'}}/{{item.allTimeShow || '0:00'}}</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="btns-txt">
                    <p class="btns setBackground">
                        <span class="btn" @click.stop="handleClick(item, 'bgm')">设为背景音乐</span>
                    </p>
                    <p class="btns">
                        <span class="btn" @click.stop="handleClick(item)">使用</span>
                    </p>
                </div>
            </div>
        </div>
        <div
            v-if="pageConfig.total>pageConfig.pageSize"
            class="footer-box-more"
        >
            <el-pagination
                    v-if="data && data.length>0"
                    :small="true"
                    background
                    layout="prev, pager, next"
                    v-bind="newPageConfig"
                    @current-change="currentChange"
            >
            </el-pagination>
        </div>
        <Roles
            v-if="isXunfei"
            ref="roles"
            :is-content="true"
            :is-file-name="true"
            :visible.sync="isXunfei"
            :selectRole.sync="selectRole"
            :defaultValue="config"
            @onXunfei="onXunfei"
        />
        <LuyinBtn
            ref="record"
            style="width:0px;height: 0px;overflow: hidden;"
            @onLuyinBtn="onLuyinBtn"
        />
        <Ma2
            v-if="isMa2"
            :visible.sync="isMa2"
            :url.sync="ma2Url"
            :categoryId.sync="categoryId"
            @onMa2="onMa2"
            @onFlash="onFlash"
        />
        <Form
            v-if="visible"
            :type.sync="newType"
            :visible.sync="visible"
            :isPlat.sync="isShop"
            :defaultValue="{categoryId: [`${categoryId}`]}"
            @success="$emit('onFlash')"
        />
    </div>
</template>

<script>
    import BMF from 'browser-md5-file'
    import { Loading } from 'element-ui'
    import {mapState} from 'vuex'
    import {
        AudioPlay,
        AudioPause,
        AudioWatchTime,
        AudioAllTime,
        getTimeFormat,
        AudioCurTime
    } from '../../../../utils/audio'
    import {upLoad, getFileStream} from "../../../../utils/upload";
    import LuyinBtn from '../../../../views/main/components/types/components/common/components/luyinBtn'
    import Roles from '../../../VoiceConfig/components/roles'
    import Ma2 from '../../../VoiceConfig/components/ma2'
    import Form from '../../../../views/main/components/types/components/common/components/uploadBtn/components/form'
    import Config from '../../../../config/app'

    import * as commonServer from '../../../../api/common'

    export default {
        name: 'music-item',
        components: {
            LuyinBtn,
            Roles,
            Ma2,
            Form
        },
        props: {
            isCocos: {
                type: Boolean,
                default: false
            },
            isAuto: {
                type: Boolean,
                default: true
            },
            // 是否是文音组件
            isWordAudio: {
                type: Boolean,
                default: false
            },
            categoryId: [String, Number],
            isShop:{
                type: Boolean,
                default: false
            },
            isEdit:{
                type: Boolean,
                default: false
            },
            data: [Array,Object],
            curEditItem: Object,
            type: String,
            loading: {
                type: Boolean,
                default: false
            },
            pageConfig: {
                type: Object,
                default: ()=>{
                    return {
                        page: 1,
                        pageSize: 15,
                        total: 1
                    }
                }
            }
        },
        computed: {
            ...mapState(['menusData']),
            // 当前类型是否和当前校区类型一致
            curTypeEqualCurUser(){
                return this.isShop === this.$store.getters.isPlat
            },
            authUpload(){
                return this.$store.getters.isPlat ?
                     this.$store.state.permissions['meterial_audio_shop_add']
                    :this.$store.state.permissions['meterial_audio_my_add']
            },
            authAiRecord(){
                return !this.isWordAudio && (this.$store.getters.isPlat ?
                    this.$store.state.permissions['meterial_audio_shop_ai_add']
                    :this.$store.state.permissions['meterial_audio_my_ai_add'])
            },
            authRecord(){
                return this.$store.getters.isPlat ?
                    this.$store.state.permissions['meterial_audio_shop_record']
                    :this.$store.state.permissions['meterial_audio_my_record']
            },
            authWxRecord(){
                return this.$store.getters.isPlat ?
                    this.$store.state.permissions['meterial_audio_shop_wx_record']
                    :this.$store.state.permissions['meterial_audio_my_wx_record']
            },
            addResource(){
                return this.isShop?'addResourceShop':'addResource'
            },
        },
        watch: {
            pageConfig(vl){this.newPageConfig = vl},
            newPageConfig(vl){this.$emit('update:pageConfig',vl)},
            loading: {
                handler (vl) {
                    if (vl) {
                        this.element = Loading.service({
                            target: document.getElementById('music-box')
                        })
                    } else {
                        this.element && this.element.close()
                    }
                },
                deep: true,
                immediate: true
            },
            categoryId: {
                handler(vl){
                    this.config['categoryId'] = [`${vl}`]
                },
                deep: true,
                immediate: true
            }
        },
        data () {
            return {
                curEditId: null, // 当前操作id
                newPageConfig: this.pageConfig,

                isMa2: false,
                ma2Url: '',

                isXunfei: false,
                selectRole: 0,
                config: {},
                audioUrl: '', // 音频地址

                newType: this.type,
                visible: false
            }
        },
        methods: {
            onFlash () {
                this.$emit('onFlash')
            },
            onXunfei(obj){
                if (!obj.url) return false
                this.uploadAudio({url: obj.url, type: 'ai', name: obj.fileName})
            },
            // 将远端地址转成文件流上传
            uploadAudio({url, type, name}) {
                // 将合成音频上传至音频素材
                // 1.将远端地址转成文件流
                // 2.将文件流上传到腾讯云
                // 3.上传合成音频到素材
                getFileStream({url, name, callback: (blob)=>{
                        const bmf = new BMF()
                        bmf.md5(blob, (err, md5)=>{
                            upLoad({isPlat: this.isShop, fileName: `${md5}.mp3`, file: blob, callback: async url=>{
                                    let newName = type === 'wx'?'微信':'合成'+'音频' + md5.slice(0,3)
                                    if(name) {
                                        newName = name
                                    }
                                    // 上传音频文件到素材列表
                                    let newUrl = this.$utils.getHtmlMd5(url)
                                    const remotepath = url.split('.com/')[1]
                                    let obj = {
                                        clientsId: this.$store.state.initConfig.school_id,
                                        sort: this.type,
                                        name: newName,
                                        alias: '',
                                        attributes: {
                                            cover: url,
                                            remotepath,
                                            md5: newUrl.indexOf('.') > -1?newUrl.split('.')[0] : newUrl
                                        }
                                    }
                                    if(`${this.categoryId}` !== `0`) obj.categoryId = this.categoryId

                                    const res = await commonServer.default[this.addResource](obj)
                                    if (`${res.status_code}` === '200') {
                                        this.$message.success('上传成功')
                                        this.$refs.roles && this.$refs.roles.handleClose()
                                        this.$emit('onFlash')
                                    } else {
                                        // this.$message.error('上传失败')
                                    }

                                }})
                        })

                    }})
            },
            onLuyinBtn(obj){
                console.log('录音==>', obj)

                // 上传服务器
                upLoad({
                    fileName: obj.name + '.wav',
                    file: obj.row,
                    callback: async (res)=>{
                        try {
                            // 上传音频文件
                            let addResource = obj.isShop?'addResourceShop':'addResource'
                            const result = await commonServer.default[addResource]({
                                ...obj,
                                clientsId: this.$store.state.initConfig.school_id,
                                sort:'audio',
                                attributes: {
                                    type: 'flash',
                                    cover: 'default.jpg',
                                    remotepath: res.split('.com/')[1],
                                    md5: res.split('.com/')[1].replace('.wav', '')
                                }
                            })
                            if(result.data.id){
                                // 如果创建成功 获取详情中的音频地址
                                this.$emit('onFlash')
                                this.$refs.record && this.$refs.record.handleClickDestroy()

                                // let getResourceDetail = obj.isShop?'getResourceShopDetail':'getResourceDetail'
                                // const detail = await commonServer.default[getResourceDetail]({
                                //     id: result.data.id,
                                //     clientsId: this.$store.state.initConfig.school_id,
                                // })
                                // console.log('音频详情==>', detail)
                                // let selectIndex = this.$utils.getIndexByAttr({attr: 'voice', data: this.newForm})
                                // this.newForm[selectIndex].value = detail.data.name
                                // this.audioUrl = detail.data.attributes.resources.url

                            }
                        }catch (e) {
                            // this.$message.error('上传音频失败')
                        }
                    }
                })

            },
            onMa2 ({url, name}) {
                console.log('扫码回调==>', url, name)

                // 将合成音频上传至音频素材
                // 1.将远端地址转成文件流
                // 2.将文件流上传到腾讯云
                // 3.上传合成音频到素材
                // this.uploadAudio({url, type: 'wx', name})
            },
            // 上传音频
            upload(){
                if(!this.curTypeEqualCurUser){
                    this.$emit('onChanageTab', 'upload')
                    return false
                }
                console.log('上传音频==>')
                this.visible = true
            },
            // 批量上传音频
            batchUpload(){
                if(!this.curTypeEqualCurUser){
                    this.$emit('onChanageTab', 'batchUpload')
                    return false
                }
                console.log('批量上传音频==>')
                this.$emit('batchUpload')
            },
            aiRecord(){
                if(!this.curTypeEqualCurUser){
                    this.$emit('onChanageTab', 'aiRecord')
                    return false
                }
                this.config = {}
                this.isXunfei = true
            },
            record(){
                if(!this.curTypeEqualCurUser){
                    this.$emit('onChanageTab', 'record')
                    return false
                }
                this.$refs.record && this.$refs.record.handleClickStart()
            },
            wxRecord(){
                if(!this.curTypeEqualCurUser){
                    this.$emit('onChanageTab', 'wxRecord')
                    return false
                }
                // 获取录音页面二维码
                // let arr = window.location.href.split('?')
                let audioName = `weixin_${new Date().getFullYear()}${new Date().getMonth()+1}${new Date().getDate()}${new Date().getMilliseconds()}`
                // this.ma2Url = `${Config.wx_web}?${arr[1]}&audioName=${audioName}`
                this.ma2Url = `${Config.wx_web}?id=${this.$route.query.id}&category_id=${this.$route.query.category_id}&school_id=${this.$route.query.school_id}&audioName=${audioName}`
                this.isMa2 = true
                // TODO 微信录制 每2秒轮询一次录音文件是否存在，
                // 如果存在则使用,超过15分钟还没上传表示上传超时 - 关闭当前二维码页面
                // 否则获取成功，走正常业务
            },
            handleClick(item, style){
                // 游戏环节判断是否支持添加
                if(!this.isCocos && this.menusData.lessonSelectedConfig?.type === 'game'){
                    this.$message.warning(this.$enums.warnType.game)
                    return false
                }
                // PPT环节判断是否支持添加
                if(!this.isCocos && this.menusData.lessonSelectedConfig?.type === 'html'){
                    this.$message.warning(this.$enums.warnType.ppt)
                    return false
                }
                console.log('添加音频==>', item)

                // 如果是文音组件，直接回调音频名称及路径
                if(this.isWordAudio){
                    this.$emit('onWordAudio', {audioName: item.alias || item.name, audioSrc: item.url})
                    this.$emit('success')
                    return false
                }

                const curEditItem = this.$_.cloneDeepWith(this.curEditItem)
                console.log('添加音频1==>', item, curEditItem)
                if(curEditItem && curEditItem.callback){
                    const callBack = this.$_.cloneDeepWith(curEditItem.callback)
                    if(callBack && callBack.id>-1){
                        this.$toCocosMessage({
                            type: callBack.type,
                            value: {
                                timestamp: this.$store.state.timestamp,
                                operationQueue:[
                                    {
                                        id: callBack.id,
                                        operation: callBack.operation,
                                        path: callBack.path + '/value',
                                        data: item.url
                                    },
                                    {
                                        id: callBack.id,
                                        operation: callBack.operation,
                                        path: callBack.path + '/name',
                                        data: item.alias || item.name
                                    }
                                ]
                            }
                        })
                        this.$emit('success')
                        return false
                    }
                }

                // 向cocos通知 添加资源
                /**
                 game: 游戏
                 resources: 资源
                 shop-resources: 公共资源（资源商城）
                 * */

                // 播放一次音频，并获取音频长
                AudioPlay({url: item.url})
                AudioAllTime((duration)=>{
                    let type = 'resources'
                    if(this.isShop) type = 'shop-resources'
                    if(this.type === 'game') type = 'game'
                    let cocosType = this.isEdit?'EditResource':'AddResource'
                    if(this.isAuto) {
                        let value = {type: this.type, url: item.url, duration: duration.seconds}
                        if(style === 'bgm'){
                            value = {
                                type: style,
                                url: item.url,
                                duration: duration.seconds,
                                isBackground: false,
                                isLoop: false,
                                isShow: false,
                                name: item.alias || item.name
                            }
                        }
                        this.$toCocosMessage({
                            ...this.curEditItem,
                            type: cocosType,
                            value
                        })
                    }
                    this.$store.dispatch('setUrlMap',{mark:'service-map-object', type, id: item.id,url: item.url})
                    this.$emit('success')
                    this.$emit('onSelect', item)
                })
            },
            // 将秒数转成 '00:00'
            getTimeDislay (second) {
                let time = second
                try {
                    time = getTimeFormat(second).displayTime
                } catch (e) {
                    console.log('转换失败==>', e)
                }

                return time
            },
            play (item, isOld) {
                AudioPlay({ url: item.url, isOld })
            },
            pause () {
                AudioPause()
            },
            selectAudio (item, index) {
                this.curEditId = item.id
                const newItem = this.$_.cloneDeepWith(item)
                console.log('选中当前播放，其他都暂停', item, index, newItem.play)
                if(!newItem.play){
                    this.handleClickPlay(item, index)
                } else {
                    this.handleClickPause(item, index)
                }
            },
            handleSelectAudio (index) {
                AudioWatchTime(this.setCurTime, index)
                AudioAllTime(this.setAllTime, index)
            },
            setCurTime (item, index) {
                const target = this.data[index]
                // console.log('监听==>', index)
                target.curTimeShow = item.displayTime
                target.curTime = item.seconds
                target.playTime = target.curTime / target.allTime * 100
            },
            setAllTime (item, index) {
                const target = this.data[index]
                target.allTimeShow = item.displayTime
                target.allTime = item.seconds
            },
            handleClickPlay (item, index) {
                console.log('开始播放==>')
                // 播放 1.暂停其他所有 2.获取当前播放总时间 3.及检测当前播放位置
                this.data.map(v => {
                    if (item.id === v.id){
                        v.play = !v.play
                    } else {
                        v.play = false
                        v.playTime = 0
                    }
                })

                // if (this.index === index) {
                    this.play(item, item.playTime>0)
                    // return
                // } else {
                //     AudioPlay({
                //         url: item.url,
                //         isOld: item.url === this.url,
                //         initial
                //     })
                // }
                // console.log('row-play')
                // this.index = index
                // const newItem = item
                // if (!initial) newItem.play = true
                // this.url = item.url
                    this.handleSelectAudio(index)
                // const fn = setTimeout(() => {
                //     clearTimeout(fn)
                // })
            },
            handleClickPause () {
                // 暂停 1.暂停所有
                this.data.map(v => {
                    v.play = false
                })
                AudioPause()
                // this.handleSelectAudio(item)
            },
            onSlider (value, item) {
                // this.moveValue = value
                // console.log('move', value)
                // console.log('move', value - this.playTime)
                if (Math.abs(value - item.playTime) > 1) {
                    item.isKuaijin = true
                    item.playTime = Math.round(value / 100 * item.allTime)
                    this.pause()
                }
            },
            // 快进到 this.playTime 继续播放
            continuePlay (value, item) {
                console.log('继续播放==>')
                AudioCurTime(Math.round(value / 100 * item.allTime))
                item.isKuaijin = false
                item.play = true
                this.play(item, item.playTime>0)
            },
            currentChange(curPage) {
                console.log("获取当前分页", curPage);
                this.$emit('onPage', curPage)
            }
        }
    }
</script>
<style>
    .txt-box .bar .el-slider__runway{
        background-color: #DCDFE6;
        position: relative;
        left: -14px;
    }
    .txt-box .bar .el-slider__button{
        width: 12px;
        height: 12px;
        border: none;
        background-color: #909399;
    }
</style>
<style lang="scss" scoped>
    .music-box{
        /*margin-left: 10px;*/
        padding-bottom: 10px;
        display: flex;
        flex: 1;
        flex-direction: column;
        /*max-width: 600px;*/

        .btns-box{
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            margin-top: 30px;

            .btn{
                padding: 0px 16px;
                background:rgba(245,247,250,1);
                border-radius:4px;
                border:1px solid rgba(220,223,230,1);
                font-size:12px;
                font-weight:400;
                color:rgba(51,51,51,1);
                line-height:36px;
                margin-right: 20px;
            }
        }

        .love{
            margin-left: 20px;

            .yishouchang{
                width: 15px;
                height: 14px;
            }
            .weishouchang{
                width: 15px;
                height: 13px;
            }
        }
        .btns-txt {
            display: flex;
            flex-direction: column;

            .btns {
                width: 60px;
                height: 28px;
                line-height: 28px;
                text-align: center;
                background: #26282E;
                border-radius: 4px;
                /*opacity: 0.8;*/
                margin-right: 10px;

                &.setBackground{
                    width: 102px;
                    height: 28px;
                    background: #FFFFFF;
                    border-radius: 4px;
                    border: 1px solid #DCDFE6;
                    position: relative;
                    left: -43px;
                    top: -10px;

                    .btn{
                        background-color: white;
                        color: #606266;
                    }
                }

                .btn {
                    font-size: 12px;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 1);
                    background: #26282E;
                    border-radius: 4px;
                }
            }
        }
        .btn{
            cursor: pointer;

            &:active{
                opacity: .8;
            }
        }
        .music-list{
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            margin: 20px 20px 10px;
            border-radius: 4px;
            justify-content: space-between;

            .list{
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                transition: all .2s linear;

                width:412px;
                height:90px;
                background:rgba(245,247,250,1);
                border-radius:4px;
                border:1px solid rgba(220,223,230,1);
                margin-bottom: 16px;
                padding-top: 8px;

                .music-txt{
                    display: flex;
                    flex-direction: column;

                    .row-one{
                        display: flex;
                        flex-direction: row;
                    }
                }

                &.active{
                    background: #EBECF2;
                }

                .name{
                    max-width: 260px;
                    padding: 0px 16px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    font-size:14px;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                    line-height:20px;
                    margin-bottom: 10px;
                }
                .operation{
                    display: flex;
                    flex-direction: row;
                    align-items: center;

                    .play{
                        width: 22px;
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        .bofang{
                            width: 11px;
                            height: 13px;
                        }
                        .zanting{
                            width: 9px;
                            height: 8px;
                        }
                    }
                }
            }
        }

        .play-bar{
            /*border: 1px solid #f1f1f1;*/
            /*margin: 10px 20px;*/
            /*padding: 6px 10px;*/
            border-radius: 4px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;

            .play{
                display: flex;
                flex-direction: row;
                align-items: center;
                .img{
                    width: 20px;
                    height: 20px;
                    margin-left: 16px;
                }
            }
            .love{
                margin-right: 60px;
            }
            .txt-box{
                display: flex;
                flex-direction: row;
                flex: 1;
                margin: 0px 30px;
                margin-right: 0px;
                align-items: center;
                .txt{
                    width: 90px;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    /*margin-left: 10px;*/
                }
                .bar{
                    width: 174px;
                }
            }
        }

    }

    .footer-box-more {
        display: flex;
        width: 100%;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
        margin-bottom: 30px;
    }
</style>
